import ChatLink from '../../chat-link';
import PhoneLink from '../../phone-link';
import {
  EVENT_WMAP_ORDER_CALL_CLICK,
  EVENT_WMAP_ORDER_CHAT_CLICK,
} from '~/constant/constants';

const OrderModifyText: React.FC<{
  storePhone: string | null;
  nationalSaleChat?: boolean | '';
  paymentReview?: boolean;
  enableMSChat: boolean;
}> = ({
  storePhone,
  nationalSaleChat = false,
  paymentReview = false,
  enableMSChat,
}) => {
  //do not render this component for payment review page
  if (paymentReview) {
    return <></>;
  }
  return (
    <>
      {storePhone && !nationalSaleChat && (
        <div className="info">
          <span className="info-icon" />
          <p tabIndex={0}>
            To modify your order, please reach out to Mattress Firm at{' '}
            <PhoneLink
              id="wmap-order-modify-call"
              phoneNumber={storePhone}
              label={storePhone}
              eventDescription={EVENT_WMAP_ORDER_CALL_CLICK}
            />
          </p>
        </div>
      )}
      {nationalSaleChat && (
        <div className="info">
          <span className="info-icon" />
          <p>
            <ChatLink
              label="To modify your order, please chat with a Sleep Expert"
              id="chat-link-modify-order"
              styleClass="link"
              eventDescription={EVENT_WMAP_ORDER_CHAT_CLICK}
              enableMSChat={enableMSChat}
            />
          </p>
        </div>
      )}
    </>
  );
};

export default OrderModifyText;
